<template>
	
	<div >
		
		<div style="margin: auto;width: 30%;">
			<el-row >
				<el-col :span="24" >
			    <el-input v-model="name"  @change="submit()" placeholder="请输入游戏名称按回车进行搜索" :clearable="true"></el-input>
				</el-col>
				
		
			</el-row>
			
			
			
			
			</div>
		<el-table :data="dataList" style="width: 30%;margin: auto;" v-loading="gameLoading" >
				      <el-table-column prop="name" label="游戏名称"></el-table-column>
	
				 <el-table-column prop="playCount" label="已玩次数"></el-table-column>
			
			<el-table-column  label="操作栏" width="100">  <template slot-scope="scope">
				<el-button type='primary'  @click="startNesGame(scope.row.id)"
				>开玩</el-button>
				
				</template></el-table-column>
				
			
					</el-table>
				
				    <el-pagination
					style="width: 40%;margin: auto;"
				      @size-change="changeLimit"
				      @current-change="changePage"
				      :current-page="page"
				      :page-sizes="[6]"
				      :page-size="limit"
				      layout="total, sizes, prev, pager, next, jumper"
				      :total="total"
				    ></el-pagination>
					
			
	</div>
</template>

<script>
export default {
  data() {
    return {
      dataList:[],
	  total:0,
	  page:1,
	  limit:6,
	  name:"",
	gameLoading:false
	
    };
	
  },
  methods: {
	  
	submit(){
	this.page=1
	this.loadPage()
	},
	loadPage(){
		this.gameLoading=true
		this.$api.getNesGamePage({page:this.page,limit:this.limit,name:this.name}).then(res=>{
			this.dataList=res.data.data
		
			this.total=res.data.total
				this.gameLoading=false
		})
	},
changePage(val){
	this.page=val
	this.loadPage()
},
changeLimit(val){
	this.limit=val
},
	startNesGame(id){

		window.open(window.location.origin+"/nes/index.html?id="+id+"&sign="+localStorage.getItem('token'),'_blank')
	},
  },
  mounted() {
  	this.loadPage()
  }
};
</script>

<style>
</style>